import React from 'react';
import { useTheme, Box, Circle, HStack, Pressable, Text } from 'native-base';
import { useOverviewState } from '../../context/overview';
import { useAuthState } from '../../context/auth';
import { useEnvState } from '../../context/env';
import { NOTIFICATIONS_TABS } from '../Constants';
const NotificationTabs = ({
  selected,
  setSelected
}) => {
  const theme = useTheme(),
    {
      colors
    } = theme;
  const overviewState = useOverviewState();
  const authState = useAuthState();
  const envState = useEnvState();
  const {
    unreadActivityCount,
    unreadMessagesCount,
    notifications
  } = overviewState;
  const setTabsDisplay = tabItem => {
    const {
      name,
      unreadCount
    } = tabItem;
    const isCurrentlySelected = name === selected;
    const tabColorMapping = {
      Activity: colors.notification.circle.notification,
      Messages: colors.notification.circle.other
    };
    return /*#__PURE__*/React.createElement(Pressable, {
      onPress: () => setSelected(name)
    }, /*#__PURE__*/React.createElement(Box, {
      borderBottomColor: isCurrentlySelected ? tabColorMapping[name] : '',
      borderBottomWidth: isCurrentlySelected ? '2' : '0',
      px: "4"
    }, /*#__PURE__*/React.createElement(HStack, {
      space: 1,
      py: "3"
    }, /*#__PURE__*/React.createElement(Text, {
      fontFamily: 'sans-serif',
      fontWeight: 'bold',
      color: tabColorMapping[name]
    }, name), /*#__PURE__*/React.createElement(Circle, {
      bg: tabColorMapping[name],
      px: "2"
    }, /*#__PURE__*/React.createElement(Text, {
      color: colors.notification.icon
    }, unreadCount)))));
  };
  let mergedNotificationTabs = NOTIFICATIONS_TABS.map(n => {
    if (n.name === 'Activity') return {
      ...n,
      unreadCount: unreadActivityCount
    };
    if (n.name === 'Messages') return envState.is_dmable_product && authState.can_send_dms ? {
      ...n,
      unreadCount: unreadMessagesCount
    } : null;
    return n;
  }).filter(n => n);
  return /*#__PURE__*/React.createElement(HStack, {
    space: 4
  }, mergedNotificationTabs.map(t => setTabsDisplay(t)));
};
export default NotificationTabs;
//# sourceMappingURL=NotificationTabs.js.map